<div class="menu-overlay" *ngIf="isMenuOpen" (click)="closeMenu()"></div>

<nav class="navbar">
  <div class="navbar-container">
    <div class="navbar-brand">
      <a href="/" class="brand-logo">
       <img src="assets/logo.png" alt="AgroSmart" width="50" height="50">
        <h1 class="brand-name">{{ 'nav.title' | translate }}</h1>
      </a>
    </div>

    <button class="menu-toggle" (click)="toggleMenu()" [class.active]="isMenuOpen">
      <span></span>
      <span></span>
      <span></span>
    </button>

    <div class="navbar-menu" [class.active]="isMenuOpen">
      <div class="navbar-actions">
        <!-- Language Selector -->
        <button mat-button [matMenuTriggerFor]="languageMenu" class="language-selector">
          <mat-icon class="language-icon">language</mat-icon>
          <span class="language-name">{{ getCurrentLanguageName() }}</span>
          <mat-icon class="language-chevron">expand_more</mat-icon>
        </button>

        <mat-menu #languageMenu="matMenu" class="language-dropdown-menu">
          @for (lang of languages; track lang.code) {
            <button mat-menu-item (click)="changeLanguage(lang.code)">
              <span>{{ lang.name }}</span>
            </button>
          }
        </mat-menu>

        @if (isAuthenticated()) {
          <!-- @if (isOperator()) {


            <mat-menu #supplierMenu="matMenu" class="supplier-dropdown-menu">
              @for (supplier of suppliers(); track supplier.id) {
                <button mat-menu-item (click)="selectSupplier(supplier)">
                  <span>{{ supplier.id }}</span>
                </button>
              }
            </mat-menu>
            <button mat-button [matMenuTriggerFor]="supplierMenu" class="supplier-selector">
              <span class="supplier-id">{{ selectedSupplier()?.id || '123' }}</span>
              <mat-icon class="supplier-chevron">expand_more</mat-icon>

            </button>
          } -->

          <div class="user-menu">
            <button mat-button [matMenuTriggerFor]="userMenu" class="user-menu-button">
              <div class="user-info">
                <span class="user-name">{{ currentUser()?.givenName || currentUser()?.name || currentUser()?.username }}</span>
                <span class="user-role">{{ getUserRole() }}</span>
              </div>
              <mat-icon class="chevron-icon">expand_more</mat-icon>
            </button>

            <mat-menu #userMenu="matMenu" class="user-dropdown-menu">
              @if (isOperator()) {
                <button mat-menu-item (click)="navigateToAdmin(); closeMenu()">
                  <mat-icon>admin_panel_settings</mat-icon>
                  <span>Админ панель</span>
                </button>
              }
              @if (isSupplier()) {
                <button mat-menu-item (click)="openChangePasswordModal()">
                  <mat-icon>lock</mat-icon>
                  <span>{{ 'nav.change_password' | translate }}</span>
                </button>
              }
              <button mat-menu-item (click)="logout(); closeMenu()">
                <mat-icon>logout</mat-icon>
                <span>{{ 'nav.logout' | translate }}</span>
              </button>
            </mat-menu>
          </div>
        } @else {
          <a routerLink="/login" class="btn-primary" (click)="closeMenu()">{{ 'nav.login' | translate }}</a>
        }
      </div>
    </div>
  </div>
</nav>


<div class="modal-backdrop" *ngIf="showLogoutModal" (click)="closeModal()"></div>

<div class="modal" *ngIf="showLogoutModal">
  <div class="modal-content">
    <h2>{{ 'nav.are_you_sure' | translate }}</h2>
    <p>{{ 'nav.confirm_logout' | translate }}</p>

    <div class="modal-actions">
      <button class="btn-cancel" (click)="closeModal()">{{ 'nav.cancel' | translate }}</button>
      <button class="btn-confirm" (click)="confirmLogout()">{{ 'nav.logout' | translate }}</button>
    </div>
  </div>
</div>

<app-change-password-modal
  *ngIf="showChangePasswordModal"
  (close)="closeChangePasswordModal()">
</app-change-password-modal>
